/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';
import msdyn365Commerce, * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetJournalPosts Input Action
 */
export class GetJournalPostsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetJournalPosts`;
    public getCacheObjectType = () => 'JournalPosts';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface IGetJournalPostData {
    title: string;
    subTitle: string;
    imageUrl: string;
    postUrl: string;
    date: string;
    category: string;
}

export interface IGetJournalPostsData {
    posts: IGetJournalPostData[];
    error?: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetJournalPostsInput();
};

const getLogger = (cittaInstrumentationKey: string): any => {
    if (process.env.CURRENT_ENVIRONMENT !== 'web' && cittaInstrumentationKey) {
        const appInsights = require('applicationinsights');
        return new appInsights.TelemetryClient(cittaInstrumentationKey);
    }
    return null
}

async function action(input: GetJournalPostsInput, ctx: Msdyn365.IActionContext): Promise<IGetJournalPostsData> {
    let telemetryClient = getLogger(ctx.requestContext.app.config.cittaInstrumentationKey);

    const logMessage = (message: string) => {
        if (telemetryClient) {
          telemetryClient.trackTrace({ message: message });
        } else {
          console.log(message);
        }
    }

    logMessage(`Entered Journal posts page`);

    const CosmosClient = require("@azure/cosmos").CosmosClient;
    const endpoint = "https://journalposts.documents.azure.com:443/";
    // TODO: Should these be hardcoded here?
    const databaseId = "JournalPosts"
    const containerId = "Items";

    const querySpec = {
        query: "SELECT * FROM c ORDER BY c.date DESC"
    };  
    
    try {    
        const journalKeyKeyvaultName = 'JournalPosts-Readonly-Key';
        const cosmosKey = await msdyn365Commerce.secretManager?.getSecretValue(journalKeyKeyvaultName, ctx.requestContext.apiSettings.baseUrl);
         
        if (!cosmosKey?.value) {
            const errors = {
                usernameError: cosmosKey?.error?.message
            };
            logMessage(`Error Journal Posts - could not retreive key vault values. ${JSON.stringify(errors)}`);
            return { 
                posts: [],
                error: JSON.stringify(errors)
            };
        }

        const client = new CosmosClient({ endpoint, key: cosmosKey.value });
        const database = client.database(databaseId);
        const container = database.container(containerId);

        // TODO: should I add some sort of paging in here or just leave it to the front end?
        const { resources: items } = await container.items
            .query(querySpec)
            .fetchAll();
            
        return {
            posts: items
        }
        // @ts-ignore
    } catch (e: any) {
        logMessage(`Error Journal Posts -failed to get posts from cosmos DB. ${JSON.stringify(e)}`);

        return { 
            posts: [],
            error: e.toString()
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetJournalPostsData>>action,
    input: createInput
});
